import React, { useState, useEffect } from "react";
import fordStyles from "../globalNavBar/GlobalNavBar.module.scss";
import lincolnStyles from "../globalNavBar/GlobalNavBar-Lincoln.module.scss";
import { Dialog, Button, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import "../../styles/sharedStyles.scss";
import { withTranslation } from "react-i18next";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import commonFordStyles from "../../styles/common/CommonStyles.module.scss";
import commonLincolnStyles from "../../styles/common/CommonStyles-Lincoln.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import CheckBox from "../checkBox/CheckBox";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    width: 600,
    maxWidth: 600,
  },
});

const ConfirmDialog = (props) => {
  const [open, setOpen] = useState(props.open);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (props.open !== open) {
      setOpen(props.open);
    }
  }, [props.open, open]);

  const changeCheckbox = () => {
    setChecked(!checked);
  };

  const { showWarningIcon, dialogProps, showSettings } = props;
  const isFordBrand = IS_FORD_BRAND(props.user && props.user.brand);
  const styles = isFordBrand ? fordStyles : lincolnStyles;
  const commonStyles = isFordBrand ? commonFordStyles : commonLincolnStyles;

  const StyledClose = styled(ClearIcon)({
    color: isFordBrand ? "#102b4e" : "#324047",
    cursor: "pointer",
    height: 30,
    width: 30,
  });

  return (
    <StyledDialog
      open={open}
      className={styles.dialog}
      onClose={props.onClose}
      maxWidth="sm"
    >
      <Grid container id="deleteDialog" data-testid="confirmSaveSettings">
        <Grid item md={12}>
          <div className={styles.headerContainer}>
            <div className={showWarningIcon && styles.titleContainer}>
              {showWarningIcon && <div className={styles.warning} />}
              {props.greenTitle ? (
                <div className={styles.greenTitle}>
                  {dialogProps && dialogProps.title}
                </div>
              ) : (
                <div
                  className={
                    props.boldTitle
                      ? styles.dialogTitleBold
                      : styles.dialogTitle
                  }
                >
                  {dialogProps && dialogProps.title}
                </div>
              )}
            </div>
            {showWarningIcon && (
              <StyledClose onClick={props.onCancel} className={styles.icon} />
            )}
          </div>
        </Grid>
        <Grid item md={12}>
          <div className={styles.descriptionContainer}>
            <div className={styles.dialogDescription}>
              {dialogProps && dialogProps.bodyText}
            </div>
          </div>
        </Grid>

        {showSettings && (
          <Grid container className={styles.settingsContainer}>
            <Grid item xs={4} className={styles.settingsHeader}>
              {dialogProps && dialogProps.markup}
            </Grid>
            <Grid item xs={4} className={styles.settingsHeader}>
              {dialogProps && dialogProps.laborRate}
            </Grid>
            <Grid item xs={4} />
            <Grid item xs={4} className={styles.settingsInfo}>
              {props.markupValue}%
            </Grid>
            <Grid item xs={4} className={styles.settingsInfo}>
              ${props.laborRateValue}
            </Grid>
          </Grid>
        )}

        {showSettings && (
          <Grid item xs={12}>
            <div className={styles.checkboxDiv}>
              <CheckBox
                checked={checked}
                isDisabled={false}
                name="checkboxBrandSettings"
                id="checkboxBrandSettings"
                label={dialogProps && dialogProps.checkbox}
                onChange={changeCheckbox}
              />
            </div>
          </Grid>
        )}

        {props.showWarning && (
          <Grid item md={12} data-testid="dealerList">
            {props.dealerList.map((dealer, index) => {
              const attribute =
                props.attributes && props.attributes[dealer.commonId];
              return (
                <div key={index} className={styles.nonStyledListItem}>
                  {dealer.name} ({dealer.dealerId + dealer.dealerSubcode}){" "}
                  {attribute}
                </div>
              );
            })}
          </Grid>
        )}
        {props.showOneButton ? (
          <Grid item md={12}>
            <div className={styles.singleDialogActions}>
              <div className={styles.oneButtonContainer}>
                <Button
                  className={commonStyles.confirmDialogButton}
                  id="confirmDialog"
                  data-testid="confirmDialog"
                  disabled={showSettings && !checked}
                  onClick={props.onConfirm}
                >
                  {dialogProps.confirm}
                </Button>
              </div>
            </div>
          </Grid>
        ) : (
          <Grid item md={12}>
            <div className={styles.dialogActions}>
              <div className={styles.buttonContainer}>
                <Button
                  className={commonStyles.cancelledDialogButton}
                  id="cancelDialog"
                  data-testid="closeDialog"
                  onClick={props.onCancel}
                >
                  {dialogProps && dialogProps.cancel}
                </Button>
              </div>
              <div className={styles.buttonContainer}>
                <Button
                  className={commonStyles.confirmDialogButton}
                  id="confirmDialog"
                  data-testid="confirmDialog"
                  disabled={showSettings && !checked}
                  onClick={props.onConfirm}
                >
                  {dialogProps && dialogProps.confirm}
                </Button>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
    </StyledDialog>
  );
};

export default withTranslation("emp")(ConfirmDialog);
